import React from "react";
import { Navigate, Outlet } from "react-router";
import Deposit from "../pages/Deposit/Deposit";
import Transaction from "../pages/Transaction/Transaction";
import AllPlatform from "../pages/AllPlatform/AllPlatform";
import Inbox from "../pages/Inbox/Inbox";
import DownloadApp from "../pages/App/DownloadApp";
import CheckIn from "../pages/CheckIn/CheckIn";
import Authenticator from "./Authenticator";
import DepositIframe from "../pages/Deposit/DepositIframe";
import Withdraw from "../pages/Withdraw/Withdraw";
import WalletSetting from "../components/SignInUp/components/WalletSetting";
import ScrollToTop from "./ScrollToTop";
import SimpleRewards from "../pages/Rewards/simpleRewards";
import SimpleVip from "../pages/Vip/simpleVip";
import VipDetail from "../pages/Vip/components/vipDetail";
import SetTransactionPassword from "../pages/Settings/pages/setTransactionPassword";
import BindSuccess from "../pages/Settings/pages/bindSuccess";
import ResetPasswordSuccess from "../pages/Settings/pages/resetPasswordSuccess";
import ResetWithdrawPasswordSuccess from "../pages/Settings/pages/resetWithdrawPasswordSuccess";
import UserSecureVerity from "../pages/Settings/pages/userSecureVerity";
import DepositSuccess from "../pages/Deposit/DepositSuccess";
import WithdrawSuccess from "../pages/Withdraw/withdrawSuccess";
import AboutUs from "../components/Rules/AboutUs";
import Privacy from "../components/Rules/Privacy";
import HelpCenter from "../components/Rules/HelpCenter";
import ServicePage from "../pages/Service/ServicePage";
import EventDetail from "../pages/EventList/EventDetail";
import DepositStepTwo from "../pages/Deposit/DepositStepTwo";
import DepositStepVip from "../pages/Deposit/DepositStepVip";
import DepositStepVipInput from "../pages/Deposit/DepositStepVipInput";
import NewProfile from "../pages/Profile/newProfile";
import DepositStepNormalCrypto from "../pages/Deposit/DepositStepNormalCrypto";
import Blog from "../pages/Blog/Blog";
import BlogDetail from "../pages/Blog/BlogDetail";
import VerifyEmail from "../pages/Settings/pages/verifyEmail";
import SendPoints from "../pages/SendPoints/SendPoints";
import SendPointsConfirm from "../pages/SendPoints/SendPointsConfirm";
import SimpleRebate from "../pages/Rebate/simpleRebate";
import TermsAndService from "../components/Rules/TermsAndService";
import Wrapper from "../components/LayoutComponents/Wrapper";
import Home from "../pages/Home/Home";
import Slot from "../pages/Slot/Slot";
import Live from "../pages/Live/Live";
import Lottery from "../pages/Lottery/Lottery";
import Fish from "../pages/Fish/Fish";
import BlockChain from "../pages/BlockChain/BlockChain";
import Arcade from "../pages/Arcade/Arcade";
import Table from "../pages/Table/Table";
import Sports from "../pages/Sports/Sports";
import Bingo from "../pages/Bingo/Bingo";
import EventPage from "../pages/EventList/EventPage";
import SettingsOther from "../pages/Settings/SettingsOther";
import InboxDetailSelector from "../pages/Inbox/InboxDetailSelector";
import GameBox from "../pages/Game/GameBox";
import CreateMachine from "../pages/CreateMachine/CreateMachine";
import GamePlatformPage from "../pages/gamePlatformPage/GamePlatformPage";
import GameWrap from "../pages/Game/GameWrap";
import SettingIndex from "../pages/ProfileSetting/SettingIndex";
import GameConfirm from "../pages/Game/components/GameConfirm";
import Signin from "../pages/Singin/Signin";
import Signup from "../pages/Signup/Signup";
import Settings from "../pages/Settings/Settings";
import CasinoGroups from "../pages/CasinoGroups/CasinoGroups";
import Search from "../pages/Search/Search";
import SimpleReferCode from "../pages/ReferCode/SimpleReferCode";
import BetRecord from "../pages/BetRecord/BetRecord";
import PersonalData from "../pages/Settings/pages/personalData";
import BindIdCard from "../pages/Settings/pages/bindIdCard";
import BindBankAccount from "../pages/Settings/pages/bindBankAccount";
import ResetPassword from "../pages/Settings/pages/resetPassword";
import ResetWithdrawPassword from "../pages/Settings/pages/resetWithdrawPassword";

const isCredit = process.env.REACT_APP_CREDIT == 1;

export const common_route = [
  // {
  //   path: "c-roulette",
  //   label: "c-roulette",
  //   element: <Roulette />,
  // },
  // {
  //   path: "n-roulette",
  //   label: "n-roulette",
  //   element: <RouletteNew />,
  // },
  {
    path: "signup",
    label: "signup",
    // hidden: isCredit,
    element: <Signup />,
  },
  {
    path: "signin",
    label: "signin",
    element: <Signin />,
  },
  {
    path: "deposit/payment-method/:uid",
    label: "inbox",
    element: (
      <Authenticator>
        <DepositStepTwo />
      </Authenticator>
    ),
    // hidden: isCredit,
    profile: true,
    children: [
      {
        path: "deposit-page",
        label: "inbox",
        element: <DepositIframe />,
        profile: true,
      },
    ],
  },
  {
    path: "deposit/payment-vip/:uid",
    label: "inbox",
    element: (
      <Authenticator>
        <DepositStepVipInput />
      </Authenticator>
    ),
    // hidden: isCredit,
    profile: true,
  },
  {
    path: "deposit/payment-crypto/:uid",
    label: "inbox",
    element: (
      <Authenticator>
        <DepositStepNormalCrypto />
      </Authenticator>
    ),
    // hidden: isCredit,
    profile: true,
  },
  {
    path: "deposit/payment-vip-success/:uid",
    label: "inbox",
    element: (
      <Authenticator>
        <DepositStepVip />
      </Authenticator>
    ),
    // hidden: isCredit,
    profile: true,
  },

  {
    path: "deposit",
    label: "deposit",
    element: (
      <Authenticator>
        <Deposit />
      </Authenticator>
    ),
    // hidden: isCredit,
    children: [
      {
        path: "deposit-success",
        label: "deposit-success",
        element: <DepositSuccess />,
      },
    ],
    profile: true,
  },
  {
    path: "betRecord",
    label: "betRecord",
    element: (
      <Authenticator>
        <BetRecord />
      </Authenticator>
    ),
    profile: true,
  },
  {
    path: "transaction",
    label: "transaction",
    element: (
      <Authenticator>
        <Transaction />
      </Authenticator>
    ),
    profile: true,
  },
  {
    path: "refer-code",
    label: "refer-code",
    element: (
      <Authenticator>
        <SimpleReferCode />
      </Authenticator>
    ),
    profile: true,
  },
  {
    path: "AllPlatform",
    label: "AllPlatform",
    element: (
      <Authenticator>
        <AllPlatform />
      </Authenticator>
    ),
  },
  {
    path: "inbox",
    label: "inbox",
    element: (
      <Authenticator>
        <Inbox />
      </Authenticator>
    ),
    children: [
      {
        path: ":inboxId",
        label: "inbox",
        element: <InboxDetailSelector />,
        profile: true,
      },
    ],
    profile: true,
  },
  {
    path: "app",
    label: "app",
    element: <DownloadApp />,
  },
  {
    path: "create-machine",
    label: "create-machine",
    element: <CreateMachine />,
  },
  {
    path: "checkin",
    label: "checkin",
    element: (
      <Authenticator>
        <CheckIn />{" "}
      </Authenticator>
    ),
  },
  {
    path: "deposit/depositfund",
    label: "depositfund",
    element: <DepositIframe />,
  },
  {
    path: "withdraw",
    label: "withdraw",
    hidden: isCredit,
    element: (
      <Authenticator>
        <Withdraw />
      </Authenticator>
    ),
    children: [
      {
        path: "withdraw-success",
        label: "withdraw-success",
        element: <WithdrawSuccess />,
      },
    ],

    profile: true,
  },
  {
    path: "send-points",
    label: "send-points",
    element: (
      <Authenticator>
        <SendPoints />
      </Authenticator>
    ),
    profile: true,
    children: [
      {
        path: "send-points-confirm",
        label: "send-points-confirm",
        element: (
          <Authenticator>
            <SendPointsConfirm />
          </Authenticator>
        ),
      },
    ],
  },
  // {
  //   path: "data",
  //   label: "profileData",
  //   element: (
  //     <Authenticator>
  //       <SimpleProfile />
  //     </Authenticator>
  //   ),
  //   profile: true,
  //   children: [
  //     {
  //       path: "point-query/:to?",
  //       label: "point-query",
  //       element: (
  //         <Authenticator>
  //           <PointQuery />
  //         </Authenticator>
  //       ),
  //     },
  //   ],
  // },
  {
    path: "data",
    label: "profileData",
    element: (
      <Authenticator>
        <NewProfile />
      </Authenticator>
    ),
    profile: true,
    children: [
      {
        path: "game-confirm/:gameName/:to/:gameUid",
        label: "game-confirm",
        element: (
          <>
            <GameConfirm />
            <Outlet />
          </>
        ),
      },
    ],
  },

  {
    path: "walletsettings",
    label: "walletsettings",
    element: <WalletSetting />,
  },
  {
    path: "settings",
    label: "settings",
    element: <Settings />,
    children: [
      {
        path: "personal-data",
        label: "personal-data",
        element: (
          <Authenticator>
            <PersonalData />
          </Authenticator>
        ),
        profile: true,
      },
      {
        path: "verify-email",
        label: "verify-email",
        element: (
          <Authenticator>
            <VerifyEmail />
          </Authenticator>
        ),
      },
      {
        path: "bind-id-card",
        label: "bind-id-card",
        element: (
          <Authenticator>
            <BindIdCard />
          </Authenticator>
        ),
        profile: true,
      },

      {
        path: "bind-bank-account",
        label: "bind-bank-account",
        element: (
          <Authenticator>
            <BindBankAccount />
          </Authenticator>
        ),
        profile: true,
      },
      {
        path: "bind-transaction-password",
        label: "bind-transaction-password",
        element: (
          <Authenticator>
            <SetTransactionPassword />
          </Authenticator>
        ),
        profile: true,
      },
      {
        path: "bind-success",
        label: "bind-success",
        element: (
          <Authenticator>
            <BindSuccess />
          </Authenticator>
        ),
        profile: true,
      },
      {
        path: "reset-password",
        label: "reset-password",
        element: (
          <Authenticator>
            <ResetPassword />
          </Authenticator>
        ),
        profile: true,
      },
      {
        path: "reset-password-success",
        label: "reset-password-success",
        element: (
          <Authenticator>
            <ResetPasswordSuccess />
          </Authenticator>
        ),
        profile: true,
      },
      {
        path: "reset-withdraw-password",
        label: "reset-withdraw-password",
        hidden: isCredit,
        element: (
          <Authenticator>
            <ResetWithdrawPassword />
          </Authenticator>
        ),
        profile: true,
      },
      {
        path: "reset-withdraw-password-success",
        label: "reset-withdraw-password-success",
        hidden: isCredit,
        element: (
          <Authenticator>
            <ResetWithdrawPasswordSuccess />
          </Authenticator>
        ),
        profile: true,
      },
      {
        path: "user-secure-verity",
        label: "user-secure-verity",
        element: <UserSecureVerity />,
        profile: true,
      },
    ],
    profile: true,
  },
  {
    path: "settingsOther",
    label: "settingsOther",
    exact: true,
    element: (
      <Authenticator>
        <SettingsOther />
      </Authenticator>
    ),
    profile: true,
  },
  {
    path: "profile/*",
    label: "profile",
    exact: true,
    element: (
      <Authenticator>
        <SettingIndex />
      </Authenticator>
    ),
    profile: true,
  },
  {
    path: "casino-group",
    label: "casino-group",
    element: <CasinoGroups />,
  },
  {
    path: "search",
    label: "search",
    element: <Search />,
    children: [
      {
        path: "game-confirm/:gameName/:to/:gameUid",
        label: "game-confirm",
        element: (
          <>
            <GameConfirm />
            <Outlet />
          </>
        ),
      },
    ],
  },
  {
    path: "rewards",
    label: "rewards",
    // hidden: isCredit,
    element: (
      <Authenticator>
        <SimpleRewards />
      </Authenticator>
    ),
    profile: true,
  },
  {
    path: "my-rebate",
    label: "my-rebate",
    element: (
      <Authenticator>
        <SimpleRebate />
      </Authenticator>
    ),
    profile: true,
  },

  {
    path: "vip",
    label: "vip",
    hidden: isCredit ? true : window.vip_open == "0" ? true : false,
    element: (
      <Authenticator>
        <SimpleVip />
      </Authenticator>
    ),
    children: [
      {
        path: ":vipId",
        label: "vip",
        element: <VipDetail />,
        profile: true,
      },
    ],
    profile: true,
  },
  {
    path: "game-confirm/:gameName/:to/:gameUid",
    label: "game-confirm",
    element: (
      <>
        <GameConfirm />
        <Outlet />
      </>
    ),
  },
];

export const rules_route = [
  {
    path: "/policies/about-us",
    label: "about-us",
    element: (
      <Wrapper scrollToTop>
        <AboutUs />
        <Outlet />
      </Wrapper>
    ),
  },
  {
    path: "/policies/terms-and-service",
    label: "Service",
    element: (
      <Wrapper scrollToTop>
        <TermsAndService />
        <Outlet />
      </Wrapper>
    ),
  },

  {
    path: "/policies/privacy",
    label: "privacy",
    element: (
      <Wrapper scrollToTop>
        <Privacy />
        <Outlet />
      </Wrapper>
    ),
  },
  {
    path: "/policies/terms",
    label: "terms",
    element: (
      <Wrapper scrollToTop>
        <Outlet />
      </Wrapper>
    ),
  },
  {
    path: "/policies/help-center",
    label: "help-center",
    element: (
      <Wrapper scrollToTop>
        <HelpCenter />
        <Outlet />
      </Wrapper>
    ),
  },
  {
    path: "/blog",
    label: "blog",
    element: (
      <Wrapper scrollToTop>
        <Blog />
        <Outlet />
      </Wrapper>
    ),
  },
  {
    path: "/blog/detail/:route_link?",
    label: "blog",
    element: (
      <Wrapper scrollToTop>
        <BlogDetail />
        <Outlet />
      </Wrapper>
    ),
  },
];

export const routes = [
  {
    path: "/promotion",
    label: "promotions",
    // hidden: isCredit,
    element: (
      <Wrapper>
        <ScrollToTop>
          <EventPage />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/promotion/detail/:uid",
    label: "promotions",
    // hidden: isCredit,
    element: (
      <Wrapper>
        <ScrollToTop>
          <EventDetail />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "service-group",
    label: "serviceGroup",
    element: <ServicePage />,
  },
  {
    path: "/slots",
    label: "slots",
    element: (
      <Wrapper>
        <ScrollToTop>
          <Slot gameMainTypeFromProps="slots" />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/bingo",
    label: "bingo",
    element: (
      <Wrapper>
        <ScrollToTop>
          <Bingo gameMainTypeFromProps="bingo" />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/fish",
    label: "fish",
    element: (
      <Wrapper>
        <ScrollToTop>
          <Fish gameMainTypeFromProps="fish" />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/arcade",
    label: "arcade",
    element: (
      <Wrapper>
        <ScrollToTop>
          <Arcade gameMainTypeFromProps="arcade" />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/block-chain",
    label: "block-chain",
    element: (
      <Wrapper>
        <ScrollToTop>
          <BlockChain gameMainTypeFromProps="block-chain" />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/lottery",
    label: "lottery",
    element: (
      <Wrapper>
        <ScrollToTop>
          <Lottery gameMainTypeFromProps="lottery" />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/live-casino",
    label: "live-casino",
    element: (
      <Wrapper>
        <ScrollToTop>
          <Live gameMainTypeFromProps="live-casino" />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/sports",
    label: "sports",
    element: (
      <Wrapper>
        <ScrollToTop>
          <Sports gameMainTypeFromProps="sports" />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/table",
    label: "table",
    element: (
      <Wrapper>
        <ScrollToTop>
          <Table gameMainTypeFromProps="table" />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  // {
  //   path: "/:gameMainType",
  //   label: "gamePlatform",
  //   element: (
  //     <WrapperV2>
  //       <ScrollToTop>
  //         <GamePlatformPageV2 />
  //         <Outlet />
  //       </ScrollToTop>
  //     </WrapperV2>
  //   ),
  // },
  {
    path: "/:gameMainType/category/:gamePlatform/*",
    label: "gamePlatform",
    element: (
      <Wrapper>
        <ScrollToTop>
          <GamePlatformPage />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/:gameMainType/category/:gamePlatform/:subType/*",
    label: "gamePlatform",
    element: (
      <Wrapper>
        <ScrollToTop>
          <GamePlatformPage />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/gamebox/:gameName/:to/:gameUid",
    label: "gameBox",
    element: (
      <Authenticator>
        <Wrapper>
          <ScrollToTop>
            {/* <OverflowHidden closePop> */}
            <GameWrap>
              <GameBox />
            </GameWrap>
            <Outlet />
            {/* </OverflowHidden> */}
          </ScrollToTop>
        </Wrapper>
      </Authenticator>
    ),
  },
  {
    path: "/",
    label: "slots",
    element: (
      <Wrapper>
        <ScrollToTop>
          <Home />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "/*",
    label: "slots",
    element: (
      <Wrapper>
        <ScrollToTop>
          <Home gameMainTypeFromProps="slots" />
          <Outlet />
        </ScrollToTop>
      </Wrapper>
    ),
  },
  {
    path: "*",
    label: "",
    element: <Navigate to="/slots" />,
  },
];
